//GET_BENEFICIARY 

export const setBeneficiary = (beneficiaryData) => ({
  type: 'SET_BENEFICIARY',
  data: beneficiaryData
});



/*export const setStateHeadings = (beneficiaryHeadings) => ({
  type: 'SET_BENEFICIARY',
  data: beneficiaryHeadings
}); */


// WEBPACK FOOTER //
// ./src/actions/beneficiary.js